import Statistics from '../Statistics'
import GreyColumn from '../GreyColumn'
import { formatDate } from 'util/formatters'

type ExtendedMedicationInfoProps = {
  medication: string
  directions: string
  notes?: string
  unit: string
  substitutions: string
  writtenDate: string
  quantity: number
  refills: number
  daysSupply?: number
  cancellationReason?: string
}

const ExtendedMedicationInfo = ({
  medication,
  directions,
  notes = '',
  unit,
  substitutions,
  writtenDate,
  quantity,
  refills,
  daysSupply,
  cancellationReason,
}: ExtendedMedicationInfoProps) => {
  const topRows = [
    {
      label: 'Medication',
      value: medication,
    },
    {
      label: 'Cancellation Reason',
      value: cancellationReason,
    },
    {
      label: 'Directions',
      value: directions,
    },
    {
      label: 'Notes',
      value: notes,
    },
  ]

  const bottomRows = [
    {
      label: 'Unit',
      value: unit,
    },
    {
      label: 'Substitutions',
      value: substitutions,
    },
    {
      label: 'Written date',
      value: formatDate(writtenDate),
    },
  ]

  return (
    <div>
      {topRows.map(({ label, value }) => (
        <GreyColumn label={label} value={value} key={label} className="mt-3" />
      ))}

      <Statistics quantity={quantity} refills={refills} daysSupply={daysSupply || 0} />

      {bottomRows.map(({ label, value }) => (
        <GreyColumn label={label} value={value} key={label} className="mt-3" />
      ))}
    </div>
  )
}

export default ExtendedMedicationInfo
